/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ attribution: "other" | "other_via_agent" | "self" | "self_via_agent" }} Plan_History_WhoInputs */

const en_us2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`You`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Your trainer, at your request`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Your coach`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Your coach, through the trainer`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const pt_br2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Você`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Seu personal, a seu pedido`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Seu treinador`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Seu treinador, pelo personal`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const es_419_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Tú`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Tu entrenador, a pedido tuyo`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Tu coach`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Tu coach, a través del entrenador`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const pt_pt2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Tu`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`O teu treinador, a teu pedido`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`O teu coach`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`O teu coach, através do treinador`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const fr_fr2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Toi`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Ton coach, à ta demande`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Ton entraîneur`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Ton entraîneur, via le coach`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const de_de2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Du`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Dein Coach, auf deinen Wunsch`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Dein Trainer`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Dein Trainer, über den Coach`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

const it_it2_plan_history_who = /** @type {(inputs: Plan_History_WhoInputs) => LocalizedString} */ (i) => {
	if (i?.attribution === "self") return /** @type {LocalizedString} */ (`Tu`);
	if (i?.attribution === "self_via_agent") return /** @type {LocalizedString} */ (`Il tuo coach, su tua richiesta`);
	if (i?.attribution === "other") return /** @type {LocalizedString} */ (`Il tuo istruttore`);
	if (i?.attribution === "other_via_agent") return /** @type {LocalizedString} */ (`Il tuo istruttore, tramite il coach`);
	return /** @type {LocalizedString} */ ("plan.history_who");
};

/**
* | attribution | output |
* | --- | --- |
* | "self" | "You" |
* | "self_via_agent" | "Your trainer, at your request" |
* | "other" | "Your coach" |
* | "other_via_agent" | "Your coach, through the trainer" |
*
* @param {Plan_History_WhoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_who = /** @type {((inputs: Plan_History_WhoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_WhoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_who(inputs)
	if (locale === "es-419") return es_419_plan_history_who(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_who(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_who(inputs)
	if (locale === "de-DE") return de_de2_plan_history_who(inputs)
	if (locale === "it-IT") return it_it2_plan_history_who(inputs)
	return en_us2_plan_history_who(inputs)
});
export { plan_history_who as "plan.history_who" }